import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { DemoProvider } from './state/DemoContext';
import DemoLayout from './components/layout/DemoLayout';
import { AuthorizationCheck } from '../../utils/AuthorizationCheck';
import Overview from './components/pages/Overview';
import ConnectSystems from './components/pages/ConnectSystems';
import Marketplace from './components/pages/Marketplace';
import AssetDetail from './components/pages/AssetDetail';
import AssetRegistry from './components/pages/AssetRegistry';
import InvestorSignup from './components/pages/InvestorSignup';
import InvestorDashboard from './components/pages/InvestorDashboard';
import ListAsset from './components/pages/ListAsset';
import Landing from './components/pages/Landing';
import BorrowingBase from './components/pages/BorrowingBase';
import AIAgents from './components/pages/AIAgents';
import Offers from './components/pages/Offers';
import AcceptOffer from './components/pages/AcceptOffer';
import LenderPOV from './components/pages/LenderPOV';
import BorrowerDashboard from './components/pages/BorrowerDashboard';
import LenderDashboard from './components/pages/LenderDashboard';
import OnboardBorrower from './components/pages/OnboardBorrower';
import OnboardLender from './components/pages/OnboardLender';
import './styles/globals.css';

// Protected Route Component - ensures all demo routes require /jo-xyz-demo permission
const ProtectedDemoRoute = ({ component: Component, auth, ...props }) => {
  const renderPage = AuthorizationCheck(auth, '/jo-xyz-demo');
  
  if (!renderPage) {
    return null; // AuthorizationCheck handles the redirect
  }
  
  return <Component {...props} />;
};

const JoXyzDemo = ({ auth }) => {
  // Use existing AuthorizationCheck to protect the demo
  const renderPage = AuthorizationCheck(auth, '/jo-xyz-demo');
  
  if (!renderPage) {
    return null; // AuthorizationCheck handles the redirect
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Jo XYZ Demo - Elliot Koss</title>
      </Helmet>
      <DemoProvider>
        <DemoLayout>
        <Switch>
          <Route exact path="/jo-xyz-demo" render={(props) => <ProtectedDemoRoute component={Landing} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/overview" render={(props) => <ProtectedDemoRoute component={Overview} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/connect" render={(props) => <ProtectedDemoRoute component={ConnectSystems} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/marketplace" render={(props) => <ProtectedDemoRoute component={Marketplace} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/asset/:id" render={(props) => <ProtectedDemoRoute component={AssetDetail} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/assets" render={(props) => <ProtectedDemoRoute component={AssetRegistry} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/investor/signup" render={(props) => <ProtectedDemoRoute component={InvestorSignup} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/investor" render={(props) => <ProtectedDemoRoute component={InvestorDashboard} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/list-asset" render={(props) => <ProtectedDemoRoute component={ListAsset} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/borrowing-base" render={(props) => <ProtectedDemoRoute component={BorrowingBase} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/agents" render={(props) => <ProtectedDemoRoute component={AIAgents} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/offers" render={(props) => <ProtectedDemoRoute component={Offers} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/accept-offer" render={(props) => <ProtectedDemoRoute component={AcceptOffer} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/lender" render={(props) => <ProtectedDemoRoute component={LenderPOV} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/borrower-dashboard" render={(props) => <ProtectedDemoRoute component={BorrowerDashboard} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/lender-dashboard" render={(props) => <ProtectedDemoRoute component={LenderDashboard} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/onboard-borrower" render={(props) => <ProtectedDemoRoute component={OnboardBorrower} auth={auth} {...props} />} />
          <Route exact path="/jo-xyz-demo/onboard-lender" render={(props) => <ProtectedDemoRoute component={OnboardLender} auth={auth} {...props} />} />
          <Route render={() => <Redirect to="/jo-xyz-demo/overview" />} />
          </Switch>
        </DemoLayout>
      </DemoProvider>
    </>
  );
};

// Connect to Redux store to get auth state
function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(JoXyzDemo);
